// extracted by mini-css-extract-plugin
module.exports = {"admin":"admin_admin__3I_Ga","imgBackground":"admin_imgBackground__2L3XQ"};